import { Hidden, Grid, Typography, Divider } from '@mui/material';
import { formatCurrencyString } from 'src/utils/currency';

const CartItem = ({
  desc,
  quantity,
  unitAmount,
  currency,
  unitSmallText,
  unitQuantStr,
  subtext,
  strikeAmt
}: {
  desc: string;
  unitAmount: number | string;
  quantity: number | string;
  currency: string;
  unitSmallText?: string;
  unitQuantStr?: string;
  subtext?: string;
  strikeAmt?: boolean;
}) => {
  return (
    <>
      <Grid container spacing={2} alignContent="center" alignItems="center">
        <Grid item xs={12} sm={6}>
          <Typography
            fontSize="0.9rem"
            lineHeight="1rem"
            margin="0.2rem 0"
            display="inline-block"
          >
            {desc}
          </Typography>
          {subtext && (
            <Typography fontSize="0.9rem" fontStyle="italic" color="#555555">
              {subtext}
            </Typography>
          )}
        </Grid>

        <Grid item xs={6} sm={3} style={{ textAlign: 'right' }}>
          <Typography
            fontSize="0.9rem"
            lineHeight="1rem"
            margin="0.2rem 0"
            display="inline-block"
            sx={{ textDecoration: strikeAmt ? 'line-through' : 'none' }}
          >
            <Hidden smUp>{unitSmallText ?? 'Unit Amount: '}</Hidden>
            {typeof unitAmount === 'string'
              ? unitAmount
              : formatCurrencyString({
                  value: unitAmount,
                  currency: currency.toUpperCase()
                })}
          </Typography>
        </Grid>
        <Grid item xs={6} sm={3} style={{ textAlign: 'right' }}>
          <Typography
            fontSize="0.9rem"
            lineHeight="1rem"
            margin="0.2rem 0"
            display="inline-block"
          >
            {typeof unitAmount === 'string' || typeof quantity === 'string'
              ? unitQuantStr
              : formatCurrencyString({
                  value: unitAmount * quantity,
                  currency: currency.toUpperCase()
                })}
          </Typography>
        </Grid>
      </Grid>
      <Divider sx={{ margin: '0.5rem 0' }} />
    </>
  );
};

export default CartItem;
